import React, { useRef, useEffect, useState } from 'react';
import Select from '@material-ui/core/Select';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import MenuItem from '@material-ui/core/MenuItem';
import InfoTooltip from './InfoTooltip';

import '../../../scss/components/_signal_planning.scss';

const GeometryTable = props => {

    const [customList, setCustomList] = useState([]);
    const [nbLeftPha, setNbLeftPha] = useState(null);
    const [sbLeftPha, setSbLeftPha] = useState(null);
    const [ebLeftPha, setEbLeftPha] = useState(null);
    const [wbLeftPha, setWbLeftPha] = useState(null);

    useEffect(() => {
        if(props.phasingList) {
            setCustomList(props.phasingList);
        }
    }, [props.phasingList, props.checkVol, props.activeData])

    const selectCmp = (catalog, val, node=null, dir=null, mov=null) => {
        let opts = [];
        if(catalog === 'number') {
            for(let i = 0; i < 8; i++) {
                opts.push({id: i, signal: i});
            }
        } else if(catalog === 'boolean') {
            opts.push({id: true, signal: 'Yes'});
            opts.push({id: false, signal: 'No'});
        } 
        
        return (
            <Select                  
                IconComponent={ExpandMoreIcon}
                MenuProps={{PaperProps:{className:'slct-details-cmp'}}}
                disabled={!props.editable}
                value={val}
                onChange={(e) => props.handleEdition(e.target.value, node, dir, mov)}
            >
                {
                    opts && opts.length > 0  ?
                    opts.map((item) => (
                        <MenuItem value={item.id}>{item.signal}</MenuItem>                        
                    ))
                    : null
                } 
            </Select>
        )
    }
    
    const gettingPhasingTxt = (val) => {
        let signal = "";
        customList.map((item) => {
            if(item['id'] === val) {
                signal = item['signal'];
            }
        })
        return signal;
    }

    const gettingParkingTxt = (val) => {
        if(val === true) {
            return "Yes"
        } else {
            return "No"
        }
    }

    return (
        <div className='calc-section'>
            <label>Intersection geometry & treatment 
                <InfoTooltip />
            </label>
            <table cellSpacing={0} className={props.editable ? "editable-table" : null}>
                <tr>
                    <td className='b-bottom b-right-dark odd' width="212px"># Lanes in lane group</td>
                    <td className='editable b-bottom b-right odd' width="85px">
                        {
                            props.editable ? 
                            selectCmp("number", props.activeData && props.activeData['lanes_in_lane_group']['NB'] ? props.activeData['lanes_in_lane_group']['NB']['left'] : null, 'lanes_in_lane_group','NB','left')
                            :
                            props.activeData&&props.activeData['lanes_in_lane_group']['NB'] ? props.activeData['lanes_in_lane_group']['NB']['left'] : null
                        }
                    </td>
                    <td className='editable b-bottom b-right odd' width="85px">
                        {
                            props.editable ? 
                            selectCmp("number", props.activeData && props.activeData['lanes_in_lane_group']['NB'] ? props.activeData['lanes_in_lane_group']['NB']['thru'] : null, 'lanes_in_lane_group','NB','thru')
                            :
                            props.activeData&&props.activeData['lanes_in_lane_group']['NB'] ? props.activeData['lanes_in_lane_group']['NB']['thru'] : null
                        }
                    </td>
                    <td className='editable b-bottom b-right-dark odd' width="85px">
                        {
                            props.editable ? 
                            selectCmp("number", props.activeData && props.activeData['lanes_in_lane_group']['NB'] ? props.activeData['lanes_in_lane_group']['NB']['right'] : null, 'lanes_in_lane_group','NB','right')
                            : 
                            props.activeData&&props.activeData['lanes_in_lane_group']['NB'] ? props.activeData['lanes_in_lane_group']['NB']['right'] : null
                        }
                    </td>
                    <td className='editable b-bottom b-right odd' width="85px">
                        {
                            props.editable ? 
                            selectCmp("number", props.activeData && props.activeData['lanes_in_lane_group']['SB'] ? props.activeData['lanes_in_lane_group']['SB']['left'] : null, 'lanes_in_lane_group','SB','left')
                            :
                            props.activeData&&props.activeData['lanes_in_lane_group']['SB'] ? props.activeData['lanes_in_lane_group']['SB']['left'] : null
                        }
                    </td>
                    <td className='editable b-bottom b-right odd' width="85px">
                        {
                            props.editable ?
                            selectCmp("number", props.activeData && props.activeData['lanes_in_lane_group']['SB'] ? props.activeData['lanes_in_lane_group']['SB']['thru'] : null, 'lanes_in_lane_group','SB','thru')
                            :
                            props.activeData&&props.activeData['lanes_in_lane_group']['SB'] ? props.activeData['lanes_in_lane_group']['SB']['thru'] : null
                        }
                    </td>
                    <td className='editable b-bottom b-right-dark odd' width="85px">
                        {
                            props.editable ? 
                            selectCmp("number", props.activeData && props.activeData['lanes_in_lane_group']['SB'] ? props.activeData['lanes_in_lane_group']['SB']['right'] : null, 'lanes_in_lane_group','SB','right')
                            :
                            props.activeData&&props.activeData['lanes_in_lane_group']['SB'] ? props.activeData['lanes_in_lane_group']['SB']['right'] : null
                        }
                    </td>
                    <td className='editable b-bottom b-right odd' width="85px">
                        {
                            props.editable ? 
                            selectCmp("number", props.activeData && props.activeData['lanes_in_lane_group']['EB'] ? props.activeData['lanes_in_lane_group']['EB']['left'] : null, 'lanes_in_lane_group','EB','left')
                            :
                            props.activeData&&props.activeData['lanes_in_lane_group']['EB'] ? props.activeData['lanes_in_lane_group']['EB']['left'] : null
                        }
                    </td>
                    <td className='editable b-bottom b-right odd' width="85px">
                        {
                            props.editable ?
                            selectCmp("number", props.activeData && props.activeData['lanes_in_lane_group']['EB'] ? props.activeData['lanes_in_lane_group']['EB']['thru'] : null, 'lanes_in_lane_group','EB','thru')
                            :
                            props.activeData&&props.activeData['lanes_in_lane_group']['EB'] ? props.activeData['lanes_in_lane_group']['EB']['thru'] : null
                        }
                    </td>
                    <td className='editable b-bottom b-right-dark odd' width="85px">
                        {
                            props.editable ? 
                            selectCmp("number", props.activeData && props.activeData['lanes_in_lane_group']['EB'] ? props.activeData['lanes_in_lane_group']['EB']['right'] : null, 'lanes_in_lane_group','EB','right')
                            :
                            props.activeData&&props.activeData['lanes_in_lane_group']['EB'] ? props.activeData['lanes_in_lane_group']['EB']['right'] : null
                        }
                    </td>
                    <td className='editable b-bottom b-right odd' width="85px">
                        {
                            props.editable ? 
                            selectCmp("number", props.activeData && props.activeData['lanes_in_lane_group']['WB'] ? props.activeData['lanes_in_lane_group']['WB']['left'] : null, 'lanes_in_lane_group','WB','left')
                            :
                            props.activeData&&props.activeData['lanes_in_lane_group']['WB'] ? props.activeData['lanes_in_lane_group']['WB']['left'] : null
                        }
                    </td>
                    <td className='editable b-bottom b-right odd' width="85px">
                        {
                            props.editable ? 
                            selectCmp("number", props.activeData && props.activeData['lanes_in_lane_group']['WB'] ? props.activeData['lanes_in_lane_group']['WB']['thru'] : null, 'lanes_in_lane_group','WB','thru')
                            :
                            props.activeData&&props.activeData['lanes_in_lane_group']['WB'] ? props.activeData['lanes_in_lane_group']['WB']['thru'] : null
                        }
                    </td>
                    <td className='editable b-bottom odd' width="85px">
                        {
                            props.editable ? 
                            selectCmp("number", props.activeData && props.activeData['lanes_in_lane_group']['WB'] ? props.activeData['lanes_in_lane_group']['WB']['right'] : null, 'lanes_in_lane_group','WB','right')
                            : 
                            props.activeData&&props.activeData['lanes_in_lane_group']['WB'] ? props.activeData['lanes_in_lane_group']['WB']['right'] : null
                        }
                    </td>
                </tr>
                <tr>
                    <td className='b-bottom b-right-dark'>Parking?</td>
                    <td className='editable b-bottom b-right-dark' colSpan={3}>
                        {
                            props.editable ? 
                            selectCmp("boolean", props.activeData && props.activeData['lanes_in_lane_group']['NB'] ? props.activeData['lanes_in_lane_group']['NB']['parking'] : null, 'lanes_in_lane_group','NB','parking')
                            :
                            props.activeData&&props.activeData['lanes_in_lane_group']['NB'] ? gettingParkingTxt(props.activeData['lanes_in_lane_group']['NB']['parking']) : null
                        }
                    </td>
                    <td className='editable b-bottom b-right-dark' colSpan={3}>
                        {
                            props.editable ? 
                            selectCmp("boolean", props.activeData && props.activeData['lanes_in_lane_group']['SB'] ? props.activeData['lanes_in_lane_group']['SB']['parking'] : null, 'lanes_in_lane_group','SB','parking')
                            :
                            props.activeData&&props.activeData['lanes_in_lane_group']['SB'] ? gettingParkingTxt(props.activeData['lanes_in_lane_group']['SB']['parking']) : null
                        }
                    </td>
                    <td className='editable b-bottom b-right-dark' colSpan={3}>
                        {
                            props.editable ? 
                            selectCmp("boolean", props.activeData && props.activeData['lanes_in_lane_group']['EB'] ? props.activeData['lanes_in_lane_group']['EB']['parking'] : null, 'lanes_in_lane_group','EB','parking')
                            :
                            props.activeData&&props.activeData['lanes_in_lane_group']['EB'] ? gettingParkingTxt(props.activeData['lanes_in_lane_group']['EB']['parking']) : null
                        }
                    </td>
                    <td className='editable b-bottom' colSpan={3}>
                        {
                            props.editable ? 
                            selectCmp("boolean", props.activeData && props.activeData['lanes_in_lane_group']['WB'] ? props.activeData['lanes_in_lane_group']['WB']['parking'] : null, 'lanes_in_lane_group','WB','parking')
                            : 
                            props.activeData&&props.activeData['lanes_in_lane_group']['WB'] ? gettingParkingTxt(props.activeData['lanes_in_lane_group']['WB']['parking']) : null
                        }
                    </td>
                </tr>
                <tr>
                    <td className='b-bottom b-right-dark odd'>Left check Vol &#x3e; 240</td>
                    <td className='b-bottom b-right-dark odd' colSpan={3}>
                        {props.activeData&&props.checkVol ? props.checkVol['NB']===true ? "Yes" : "No" : ""}
                    </td>
                    <td className='b-bottom b-right-dark odd' colSpan={3}>
                        {props.activeData&&props.checkVol ? props.checkVol['SB']===true ? "Yes" : "No" : ""}
                    </td>
                    <td className='b-bottom b-right-dark odd' colSpan={3}>
                        {props.activeData&&props.checkVol ? props.checkVol['EB']===true ? "Yes" : "No" : ""}
                    </td>
                    <td className='b-bottom odd' colSpan={3}>
                        {props.activeData&&props.checkVol ? props.checkVol['WB']===true ? "Yes" : "No" : ""}
                    </td>
                </tr>
                <tr>
                    <td className='b-bottom b-right-dark'>Left cross product</td>
                    <td className='b-bottom b-right-dark' colSpan={3}>
                        {props.activeData ? props.leftCross['NB']===true ? "Yes" : "No" : ""}
                    </td>
                    <td className='b-bottom b-right-dark' colSpan={3}>
                        {props.activeData ? props.leftCross['SB']===true ? "Yes" : "No" : ""}
                    </td>
                    <td className='b-bottom b-right-dark' colSpan={3}>
                        {props.activeData ? props.leftCross['EB']===true ? "Yes" : "No" : ""}
                    </td>
                    <td className='b-bottom' colSpan={3}>
                        {props.activeData ? props.leftCross['WB']===true ? "Yes" : "No" : ""}
                    </td>
                </tr>
                <tr>
                    <td className='b-bottom b-right-dark odd'>Left lanes greater than 1</td>
                    <td className='b-bottom b-right-dark odd' colSpan={3}>
                        {props.activeData && props.activeData['lanes_in_lane_group']['NB'] ? props.activeData['lanes_in_lane_group']['NB']['left_lanes_greater']===true ? "Yes" : "No" : ""}
                    </td>
                    <td className='b-bottom b-right-dark odd' colSpan={3}>
                        {props.activeData && props.activeData['lanes_in_lane_group']['SB'] ? props.activeData['lanes_in_lane_group']['SB']['left_lanes_greater']===true ? "Yes" : "No" : ""}
                    </td>
                    <td className='b-bottom b-right-dark odd' colSpan={3}>
                        {props.activeData && props.activeData['lanes_in_lane_group']['EB'] ? props.activeData['lanes_in_lane_group']['EB']['left_lanes_greater']===true ? "Yes" : "No" : ""}
                    </td>
                    <td className='b-bottom odd' colSpan={3}>
                        {props.activeData && props.activeData['lanes_in_lane_group']['WB'] ? props.activeData['lanes_in_lane_group']['WB']['left_lanes_greater']===true ? "Yes" : "No" : ""}
                    </td>
                </tr>
                <tr>
                    <td className='b-bottom b-right-dark'>Ex. LT + Opp. App. Prot.</td>
                    <td className='b-bottom b-right-dark' colSpan={3}>
                        {props.activeData ? props.oppApp['NB']===true ? "Yes" : "No" : ""}
                    </td>
                    <td className='b-bottom b-right-dark' colSpan={3}>
                        {props.activeData ? props.oppApp['SB']===true ? "Yes" : "No" : ""}
                    </td>
                    <td className='b-bottom b-right-dark' colSpan={3}>
                        {props.activeData ? props.oppApp['EB']===true ? "Yes" : "No" : ""}
                    </td>
                    <td className='b-bottom' colSpan={3}>
                        {props.activeData ? props.oppApp['WB']===true ? "Yes" : "No" : ""}
                    </td>
                </tr>
                <tr>
                    <td className='b-bottom b-right-dark odd'>Left-turn treatment</td>
                    <td className='editable b-bottom b-right-dark odd' colSpan={3}>
                        {
                            props.editable ? 
                            <Select                  
                                IconComponent={ExpandMoreIcon}
                                MenuProps={{PaperProps:{className:'slct-details-cmp'}}}
                                disabled={!props.editable}
                                value={props.activeData&&props.activeData['lanes_in_lane_group']['NB'] ? props.activeData['lanes_in_lane_group']['NB']['left_phasing'] : null}
                                onChange={(e)=>props.handleEdition(e.target.value,'lanes_in_lane_group','NB','left_phasing')}
                            >
                                {
                                    customList.length > 0  &&
                                    customList.map((item) => (
                                        <MenuItem value={item.id}>{item.signal}</MenuItem>                        
                                    ))
                                } 
                            </Select>
                            :
                            props.activeData&&props.activeData['lanes_in_lane_group']['NB'] ? gettingPhasingTxt(props.activeData['lanes_in_lane_group']['NB']['left_phasing']) : gettingPhasingTxt(0)
                        }
                    </td>
                    <td className='editable b-bottom b-right-dark odd' colSpan={3}>
                        {
                            props.editable ? 
                            <Select                  
                                IconComponent={ExpandMoreIcon}
                                MenuProps={{PaperProps:{className:'slct-details-cmp'}}}
                                disabled={!props.editable}
                                value={props.activeData&&props.activeData['lanes_in_lane_group']['SB'] ? props.activeData['lanes_in_lane_group']['SB']['left_phasing'] : null}
                                onChange={(e)=>props.handleEdition(e.target.value,'lanes_in_lane_group','SB','left_phasing')}
                            >
                                {
                                    customList.length > 0  &&
                                    customList.map((item) => (
                                        <MenuItem value={item.id}>{item.signal}</MenuItem>                        
                                    ))
                                } 
                            </Select>
                            :
                            props.activeData&&props.activeData['lanes_in_lane_group']['SB'] ? gettingPhasingTxt(props.activeData['lanes_in_lane_group']['SB']['left_phasing']) : gettingPhasingTxt(0)
                        }
                    </td>
                    <td className='editable b-bottom b-right-dark odd' colSpan={3}>
                        {
                            props.editable ? 
                            <Select                  
                                IconComponent={ExpandMoreIcon}
                                MenuProps={{PaperProps:{className:'slct-details-cmp'}}}
                                disabled={!props.editable}
                                value={props.activeData&&props.activeData['lanes_in_lane_group']['EB'] ? props.activeData['lanes_in_lane_group']['EB']['left_phasing'] : null}
                                onChange={(e)=>props.handleEdition(e.target.value,'lanes_in_lane_group','EB','left_phasing')}
                            >
                                {
                                    customList.length > 0  &&
                                    customList.map((item) => (
                                        <MenuItem value={item.id}>{item.signal}</MenuItem>                        
                                    ))
                                } 
                            </Select>
                            :
                            props.activeData&&props.activeData['lanes_in_lane_group']['EB'] ? gettingPhasingTxt(props.activeData['lanes_in_lane_group']['EB']['left_phasing']) : gettingPhasingTxt(0)
                        }
                    </td>
                    <td className='editable b-bottom odd' colSpan={3}>
                        {
                            props.editable ? 
                            <Select                  
                                IconComponent={ExpandMoreIcon}
                                MenuProps={{PaperProps:{className:'slct-details-cmp'}}}
                                disabled={!props.editable}
                                value={props.activeData&&props.activeData['lanes_in_lane_group']['WB'] ? props.activeData['lanes_in_lane_group']['WB']['left_phasing'] : null}
                                onChange={(e)=>props.handleEdition(e.target.value,'lanes_in_lane_group','WB','left_phasing')}
                            >
                                {
                                    customList.length > 0  &&
                                    customList.map((item) => (
                                        <MenuItem value={item.id}>{item.signal}</MenuItem>                        
                                    ))
                                } 
                            </Select>
                            :
                            props.activeData&&props.activeData['lanes_in_lane_group']['WB'] ? gettingPhasingTxt(props.activeData['lanes_in_lane_group']['WB']['left_phasing']) : gettingPhasingTxt(0)
                        }
                    </td>
                </tr>
                <tr>
                    <td className='b-bottom b-right-dark'>Right-turn treatment</td>
                    <td className='editable b-bottom b-right-dark' colSpan={3}>
                        {
                            props.editable ? 
                            <Select                  
                                IconComponent={ExpandMoreIcon}
                                MenuProps={{PaperProps:{className:'slct-details-cmp'}}}
                                disabled={!props.editable}
                                value={props.activeData && props.activeData['lanes_in_lane_group']['NB']['right_phasing'] ? props.activeData['lanes_in_lane_group']['NB']['right_phasing'] : 0}
                                onChange={(e)=>props.handleEdition(e.target.value,'lanes_in_lane_group','NB','right_phasing')}
                            >
                                {
                                    customList.length > 0  &&
                                    customList.map((item) => (
                                        <MenuItem value={item.id}>{item.signal}</MenuItem>                        
                                    ))
                                } 
                            </Select>
                            :
                            props.activeData&&props.activeData['lanes_in_lane_group']['NB'] ? gettingPhasingTxt(props.activeData['lanes_in_lane_group']['NB']['right_phasing']) : gettingPhasingTxt(0)
                        }
                    </td>
                    <td className='editable b-bottom b-right-dark' colSpan={3}>
                        {
                            props.editable ? 
                            <Select                  
                                IconComponent={ExpandMoreIcon}
                                MenuProps={{PaperProps:{className:'slct-details-cmp'}}}
                                disabled={!props.editable}
                                value={props.activeData && props.activeData['lanes_in_lane_group']['SB']['right_phasing'] ? props.activeData['lanes_in_lane_group']['SB']['right_phasing'] : 0}
                                onChange={(e)=>props.handleEdition(e.target.value,'lanes_in_lane_group','SB','right_phasing')}
                            >
                                {
                                    customList.length > 0  &&
                                    customList.map((item) => (
                                        <MenuItem value={item.id}>{item.signal}</MenuItem>                        
                                    ))
                                } 
                            </Select>
                            :
                            props.activeData&&props.activeData['lanes_in_lane_group']['SB'] ? gettingPhasingTxt(props.activeData['lanes_in_lane_group']['SB']['right_phasing']) : gettingPhasingTxt(0)
                        }
                    </td>
                    <td className='editable b-bottom b-right-dark' colSpan={3}>
                        {
                            props.editable ? 
                            <Select                  
                                IconComponent={ExpandMoreIcon}
                                MenuProps={{PaperProps:{className:'slct-details-cmp'}}}
                                disabled={!props.editable}
                                value={props.activeData && props.activeData['lanes_in_lane_group']['EB']['right_phasing'] ? props.activeData['lanes_in_lane_group']['EB']['right_phasing'] : 0}
                                onChange={(e)=>props.handleEdition(e.target.value,'lanes_in_lane_group','EB','right_phasing')}
                            >
                                {
                                    customList.length > 0  &&
                                    customList.map((item) => (
                                        <MenuItem value={item.id}>{item.signal}</MenuItem>                        
                                    ))
                                } 
                            </Select>
                            :
                            props.activeData&&props.activeData['lanes_in_lane_group']['EB'] ? gettingPhasingTxt(props.activeData['lanes_in_lane_group']['EB']['right_phasing']) : gettingPhasingTxt(0)
                        }
                    </td>
                    <td className='editable b-bottom' colSpan={3}>
                        {
                            props.editable ? 
                            <Select                  
                                IconComponent={ExpandMoreIcon}
                                MenuProps={{PaperProps:{className:'slct-details-cmp'}}}
                                disabled={!props.editable}
                                value={props.activeData && props.activeData['lanes_in_lane_group']['WB']['right_phasing'] ? props.activeData['lanes_in_lane_group']['WB']['right_phasing'] : 0}
                                onChange={(e)=>props.handleEdition(e.target.value,'lanes_in_lane_group','WB','right_phasing')}
                            >
                                {
                                    customList.length > 0  &&
                                    customList.map((item) => (
                                        <MenuItem value={item.id}>{item.signal}</MenuItem>                        
                                    ))
                                } 
                            </Select>
                            :
                            props.activeData&&props.activeData['lanes_in_lane_group']['WB'] ? gettingPhasingTxt(props.activeData['lanes_in_lane_group']['WB']['right_phasing']) : gettingPhasingTxt(0)
                        }
                    </td>
                </tr>
            </table>
        </div>
    )

}

export default GeometryTable;